import IconButton from "@mui/material/IconButton";
import Icon from "@mdi/react";
import { mdiTableArrowDown } from "@mdi/js";
import { useQueryTrend } from "../../hooks/top21ApiHooks";
import { useAppStore } from "../../store/appStore";
const XLSX = require("xlsx");

const DataExportButton = () => {
	const listOption = useAppStore((state) => state.listOption);
	const top21TrendsRangeStart = useAppStore(
		(state) => state.top21TrendsRangeStart
	);
	const top21TrendsRangeEnd = useAppStore((state) => state.top21TrendsRangeEnd);
	const top21TrendsInterval = useAppStore((state) => state.top21TrendsInterval);
	const top21TimeFilter = useAppStore((state) => state.top21TimeFilter);

	const { isLoading, isError, data } = useQueryTrend({
		listOption,
		timeRangeMin: top21TrendsRangeStart,
		timeRangeMax: top21TrendsRangeEnd,
		timeInterval: top21TrendsInterval,
		timeFilter: top21TimeFilter
	});
	
	return (
		<IconButton
			onClick={() => {
				if (isLoading) return;
				if (isError) return;

				const worksheetVotes = XLSX.utils.json_to_sheet([
					...data.records.map((record) => {
						const row = { id: record.id };

						record.votes.forEach(({ x, y }) => {
							row[x] = y;
						});

						return row;
					}),
				]);
				const worksheetRanks = XLSX.utils.json_to_sheet([
					...data.records.map((record) => {
						const row = { id: record.id };

						record.ranks.forEach(({ x, y }) => {
							row[x] = y;
						});

						return row;
					}),
				]);
				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheetVotes, "Vote");
				XLSX.utils.book_append_sheet(workbook, worksheetRanks, "Rank");
				XLSX.writeFile(workbook, "top21.xlsx");
			}}
		>
			<Icon size={1} path={mdiTableArrowDown} />
		</IconButton>
	);
};

export default DataExportButton;
